import { ChatMessage } from '../models/ChatMessage';
import { ChatConfig } from './ChatConfig';
import { ChatService } from './ChatService';

/**
 * Chat service facade
 */
export class Chat {
    public static connect(): WebSocket {
        return ChatService.getInstance().connect();
    }

    public static configure(config: Partial<ChatConfig>): void {
        ChatService.getInstance().configure(config);
    }

    public static getRooms() {
        return ChatService.getInstance().getRooms();
    }

    public static getMessagesByRoomID(roomId: number) {
        return ChatService.getInstance().getMessagesByRoomID(roomId);
    }

    public static postMessage(message: Partial<ChatMessage>) {
        return ChatService.getInstance().postMessage(message);
    }

    public static readMessageOfRoom(messageId: number, roomId: number) {
        return ChatService.getInstance().readMessageOfRoom(messageId, roomId);
    }
}
